import React from 'react';
import { motion } from 'framer-motion';
import { Printer } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b-4 border-black" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-64">
        <div className="flex items-center gap-2" data-id="element-65">
          <Printer className="w-8 h-8" strokeWidth={2.5} data-id="element-66" />
          <span className="font-display font-bold text-2xl tracking-wider uppercase hidden sm:inline" data-id="element-67">
            STRATA CUSTOM APPAREL
          </span>
        </div>
        <a href="tel:+18582542524" className="hidden md:flex items-center gap-2 text-sm font-bold uppercase tracking-wider hover:text-gray-600 transition-colors" data-id="element-68">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-69">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" data-id="element-70" />
          </svg>
          1-858-254-2524
        </a>
        <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
        behavior: 'smooth'
      })} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-black text-white px-6 py-2.5 font-display font-bold uppercase tracking-widest text-sm hover:bg-neutral-800 transition-colors" data-id="element-71">
          Get a Fast Quote
        </motion.button>
      </div>
    </header>;
}